import { LegendOrdinal } from '@visx/legend'
import { DataContext } from '@visx/xychart'
import React, { useContext } from 'react'

export default function ChartLegend() {
  const { colorScale, theme } = useContext( DataContext )

  return (
    <LegendOrdinal
      direction="row"
      itemMargin="8px 8px 8px 0"
      scale={colorScale}
      labelFormat={( label ) => {
        return label === 'person' ? 'People' : 'Dogs'
      }}
      shape="rect"
      labelAlign="center"
      style={{
        backgroundColor : theme.backgroundColor,
        marginTop : -24,
        display : 'flex', // required in addition to `direction` if overriding styles
        justifyContent : 'center'
      }}/>
  )
}
